import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

const Ctx = createContext(null);
export const useApp = () => useContext(Ctx);

const loadCart = () => {
  try { return JSON.parse(localStorage.getItem("bs_cart")) || []; } catch { return []; }
};

export function AppProvider({ children }) {
  const [user, setUser] = useState(undefined);
  const [config, setConfig] = useState(null);
  const [cart, setCart] = useState(loadCart);
  const [shareProduct, setShareProduct] = useState(null);
  const [sharePuja, setSharePuja] = useState(false);
  const navigate = useNavigate();

  const refreshMe = useCallback(async () => {
    if (!localStorage.getItem("bs_token")) return setUser(null);
    try { setUser((await api.get("/auth/me")).data); } catch { localStorage.removeItem("bs_token"); setUser(null); }
  }, []);

  useEffect(() => { refreshMe(); api.get("/config").then((r) => setConfig(r.data)); }, [refreshMe]);
  useEffect(() => { localStorage.setItem("bs_cart", JSON.stringify(cart)); }, [cart]);

  const login = (token, u) => { localStorage.setItem("bs_token", token); setUser(u); };
  const logout = () => { localStorage.removeItem("bs_token"); setUser(null); navigate("/"); toast("Logged out"); };

  const requireAuth = (fn) => (...args) => {
    if (!user) { toast("Please log in to continue 🙏"); navigate("/login"); return; }
    return fn(...args);
  };

  const addToCart = (p, qty = 1) => {
    setCart((c) => {
      const ex = c.find((i) => i.id === p.id);
      if (ex) return c.map((i) => (i.id === p.id ? { ...i, qty: Math.min(20, i.qty + qty) } : i));
      return [...c, { id: p.id, slug: p.slug, name: p.name, image: p.image || p.images?.[0], price: p.price, mrp: p.mrp, qty }];
    });
    toast.success(`${p.name} added to cart`);
  };
  const setQty = (id, qty) => setCart((c) => (qty < 1 ? c.filter((i) => i.id !== id) : c.map((i) => (i.id === id ? { ...i, qty } : i))));
  const clearCart = () => setCart([]);
  const pct = config?.referral?.percent ?? 2;
  const refOn = config?.referral?.enabled !== false;

  return (
    <Ctx.Provider value={{ user, setUser, refreshMe, login, logout, config, cart, addToCart, setQty, clearCart, requireAuth,
      shareProduct, setShareProduct, sharePuja, setSharePuja, pct, refOn }}>
      {children}
    </Ctx.Provider>
  );
}
